import { useState } from 'react'

import {
  Box,
  Button,
  Text,
  WizardStepRenderParams,
  useOnNext,
} from '@factorialco/deprecated-design-system'
import { CreateTrainingsTrainingClassAttachmentsInput } from 'generated/resources/graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { NewFileModal } from 'modules/trainings/components/Files/NewFileModal'
import { ClassWizardData } from 'modules/trainings/components/Revamp/NewClassWizard/hooks/useNewClassWizardSteps'

import { AttachmentsList } from './AttachmentsList'

export const AttachmentsStep = ({
  data,
  onDataChanged,
}: WizardStepRenderParams<ClassWizardData>) => {
  const [showModal, setShowModal] = useState<boolean>(false)

  const onSubmit = (attachment: CreateTrainingsTrainingClassAttachmentsInput) => {
    setShowModal(false)
    const attachments = data.attachments
    if (!attachments) {
      onDataChanged({ ...data, attachments: [attachment.file] })
      return
    }

    attachments.push(attachment)
    onDataChanged({ ...data, attachments: attachments })
  }

  const onDelete = (index: number) => {
    const attachments = data.attachments
    if (!attachments) return

    attachments.splice(index, 1)
    onDataChanged({ ...data, attachments: attachments })
  }

  useOnNext(() => {
    track(trackingEvents.training.trainingGroupCreationWizard.saveNewGroupWizard)
  })

  return (
    <Box gap="s16" paddingX="s16">
      <Box gap="s8">
        <Text size="400" weight="semibold" color="grey1000">
          {i18n.t('trainings.trainings_revamp.training_class.class_wizard.attachments_step.title')}
        </Text>
        <Text size="200" weight="normal">
          {i18n.t(
            'trainings.trainings_revamp.training_class.class_wizard.attachments_step.reviewed_copies.description'
          )}
        </Text>
      </Box>
      <Button type="secondary" iconName="paperclip" onClick={() => setShowModal(true)}>
        {i18n.t('trainings.trainings_revamp.training_class.class_wizard.attachments_step.action')}
      </Button>
      {showModal && (
        <NewFileModal
          title={i18n.t(
            'trainings.trainings_revamp.training_class.class_wizard.attachments_step.new_file_modal.title'
          )}
          description={i18n.t(
            'trainings.trainings_revamp.training_class.class_wizard.attachments_step.new_file_modal.description'
          )}
          onClose={() => setShowModal(false)}
          onSubmit={async (att) => {
            switch (att.type) {
              case 'file':
                onSubmit({
                  authorId: att.authorId,
                  file: att.file,
                  title: att.title,
                  visibility: true,
                })
                break
              case 'signedId':
                onSubmit({
                  authorId: att.authorId,
                  signedId: att.signedId,
                  file: att.file,
                  title: att.title,
                  visibility: true,
                })
                break
              default:
                throw new Error('Invalid file type')
            }
          }}
          resourceType="Trainings::TrainingClass"
        />
      )}
      {data.attachments && data.attachments.length > 0 && (
        <Box gap="s8">
          <Text size="200" weight="semibold">
            {i18n.t(
              'trainings.trainings_revamp.training_class.class_wizard.attachments_step.attachments'
            )}
          </Text>
          <AttachmentsList attachments={data.attachments} onDelete={onDelete} />
        </Box>
      )}
    </Box>
  )
}
